import { Injectable } from '@angular/core';
import {combineLatest, Observable, of, timer} from 'rxjs';
import {OnDestroyMixin} from '@w11k/ngx-componentdestroyed';
import {AbstractControl} from '@angular/forms';
import {map, switchMap} from 'rxjs/operators';

import {ResourceService} from '../../../services/resource.service';

@Injectable()
export abstract class CreateEditHoldingService extends OnDestroyMixin {
  public readonly forbiddenCharsInHoldingName = this.resourceService.forbiddenCharactersInHoldingName;
  protected abstract isHoldingNameExist(holdingName: string): Observable<boolean>;

  protected constructor(protected resourceService: ResourceService) {
    super();
  }

  /**
   * Checks if holding name is valid
   */
  protected validateHoldingName(control: AbstractControl, originalValue = '') {
    const {value}: { value: string } = control;
    if (!value || value === originalValue) {
      return of(null);
    }

    return timer(1000).pipe(
      switchMap(_ => combineLatest([this.isHoldingNameContainsForbiddenCharacter(value), this.isHoldingNameExist(value)])),
      map(([includesForbiddenCharacter, nameExist]) => {
        if (includesForbiddenCharacter) {
          return {includeForbiddenCharacter: true};
        } else if (nameExist) {
          return {holdingNameTaken: true};
        }

        return null;
      })
    );
  }

  /**
   * Checks if holding's name contains forbidden character
   * @param holdingName holding name
   */
  private isHoldingNameContainsForbiddenCharacter(holdingName: string): Observable<boolean> {
    return of(this.forbiddenCharsInHoldingName.some(char => holdingName.indexOf(char) !== -1));
  }
}
